var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dropdown-menu__item list-none mb-1",class:{
    'is-disabled': _vm.disabled,
  },attrs:{"tabindex":_vm.disabled ? null : -1,"aria-disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }